import ProgressIndicator from 'components/ProgressIndicator';

import useProgressIndicator from './useProgressIndicator';

import ApplyBackButton from '../ApplyBackButton';

const ProgressHeaderIndicator: React.FunctionComponent = function () {
  const { items } = useProgressIndicator();
  return (
    <div className="lg:hidden flex flex-col sticky top-[65px] md:top-[73px] z-50">
      <ProgressIndicator items={items} lastPassed />
      <div className="flex md:hidden w-full bg-neutral-000 border-b border-neutral-200 py-1.5">
        <ApplyBackButton />
      </div>
    </div>
  );
};

export default ProgressHeaderIndicator;
